export enum Brand {
  PokerStars = 0x00000001,
  PokerStarsCasino = 0x00000002,
  BetStars = 0x00000004,
  FullTilt = 0x00000040,
  Unknown = 0x00000080,
  PokerStarsVegas = 0x00000100,
  FoxBet = 0x2000
}
